import { SyncFormFormFields, TSyncProductsFormValues } from '../helpers';
import { IAkeneoSyncProductsDTO } from '@/models/akeneoSync.model';

class SyncByEntityDTO implements IAkeneoSyncProductsDTO {
  type: string;

  channelSlugs: string[];

  updatedFrom: string;

  updatedUntil: string;

  constructor(values: TSyncProductsFormValues) {
    this.type = values[SyncFormFormFields.TYPE];
    this.channelSlugs = values[SyncFormFormFields.CHANNEL_SLUGS];
    this.updatedFrom = values[SyncFormFormFields.UPDATED_FROM];
    this.updatedUntil = values[SyncFormFormFields.UPDATED_UNTIL];
  }
}

export default SyncByEntityDTO;
